import React, { createContext, useContext } from "react"
import _ from "lodash"

import { useLayout } from "@Quiz/layout"

const COUNTDOWN_BULLETS_MOBILE = 18
const COUNTDOWN_BULLETS_DESKTOP = 34

interface ICountdownContext {
  hasCountdown: boolean
  perc: number // 0..100
  started: boolean
}

export const CountdownContext = createContext<ICountdownContext>({
  hasCountdown: false,
  perc: 0,
  started: false
})
CountdownContext.displayName = "CountdownContext"

export const useCountdown = () => useContext(CountdownContext)

type ICountdownVariant = "muchTime" | "middle" | "almostOver" | "notStarted"

export const Countdown: React.FC = () => {
  const { hasCountdown, perc, started } = useCountdown()
  const { type: layoutType } = useLayout()
  if (!hasCountdown) { return null }

  const numBullets = layoutType === "desktop" ? COUNTDOWN_BULLETS_DESKTOP : COUNTDOWN_BULLETS_MOBILE
  let variant: ICountdownVariant = started ? "muchTime" : "notStarted"
  if (perc < 25) {
    variant = "almostOver"
  } else if (perc < 51) {
    variant = "middle"
  }

  return (
    <div className="neo__countdown__holder">
      <div className={`neo__countdown neo__countdown--${variant}`}>
        {_.times(numBullets, (i) => {
          const visible = perc > 0 && (((i * 1.0 / (numBullets - 1)) * 100) <= perc)
          return (
            <div key={i} className={`neo__countdown__bullet ${visible ? "" : "--hidden"}`} />
          )
        })}
      </div>
    </div>
  )
}

export default Countdown
